import React, {useContext} from 'react';
import axios from "axios";
import {prefixUrl} from "../../../utils/utilsData";
import {SellFactorSCLContext} from "../SellFactorContext";
import {toast} from "react-toastify";
import {mySendData} from "../SellSclFactor";

function SubmitButton(props) {

  const helper = useContext(SellFactorSCLContext);
  const setData = helper.setData
  const data = helper.data

  const resetFormSellFactorScl = () => {

    setData({sendData: mySendData})
  }

  const handleSubmitSellSclFactor = async () => {
    try {

      const tmp = {
        "request": "factorConfirm", "factorData": data.sendData,
      }
      const id = toast.loading("در حال ارسال اطلاعات...")
      const res = await axios.post(prefixUrl() + "/SCLFactor/index.php", tmp)
      toast.dismiss(id)
      if (res.data.status) {
        toast.success(res.data.message);
        resetFormSellFactorScl()
      }else {
        toast.error(res.data.message)

      }
    } catch (error) {
      console.log(error)
    }
  }
  return (<div>
    <button
      className="btnCustom btnSubmit mt-5  py-5 w-100"
      onClick={handleSubmitSellSclFactor}
    >
      ثبت
    </button>
  </div>);
}

export default SubmitButton;